Bingo.FlashMessages = {};

Bingo.FlashMessages.init = function () {
    $('.flash-messages div.flash:not(data-flash-initialized)').each((index, item) => {
        const el = $(item);
        el.attr('data-flash-initialized', true);

        const close = $(document.createElement('span'));
        close.html('&#10005;');
        close.attr('class', 'close');
        close.click(() => {
            el.remove();
        });

        el.append(close);
    });
};
